import React, { useState } from 'react';
import AuthModal from './AuthModal';
import './landing.css';


// ── App Dashboard Mockup ───────────────────────────────────────────────────────
function DashboardMockup() {
  return (
    <div className="lp-mockup">
      {/* Browser chrome */}
      <div className="lp-mockup-chrome">
        <div className="lp-mockup-dots">
          <div className="lp-mockup-dot" />
          <div className="lp-mockup-dot" />
          <div className="lp-mockup-dot" />
        </div>
        <div className="lp-mockup-url">
          <span className="lp-mockup-url-lock">🔒</span>
          app.3aimigos.com
        </div>
      </div>

      {/* App shell */}
      <div className="lp-app-shell">
        {/* Sidebar */}
        <div className="lp-app-sidebar">
          <div className="lp-app-sidebar-logo">
            <span style={{ color: '#60a5fa' }}>RE</span> Suite
          </div>
          <div className="lp-app-sidebar-section">Projects</div>
          <div className="lp-app-sidebar-item lp-app-sidebar-item--active">
            <div className="lp-app-sidebar-dot lp-app-sidebar-dot--active" />
            <span className="lp-app-sidebar-item-label">Maple Properties</span>
          </div>
          <div className="lp-app-sidebar-item">
            <div className="lp-app-sidebar-dot" />
            <span className="lp-app-sidebar-item-label">Website Relaunch</span>
          </div>
          <div className="lp-app-sidebar-item">
            <div className="lp-app-sidebar-dot" />
            <span className="lp-app-sidebar-item-label">Listings Q2</span>
          </div>
          <div className="lp-app-sidebar-section">Recent</div>
          <div className="lp-app-sidebar-item">
            <div className="lp-app-sidebar-dot" />
            <span className="lp-app-sidebar-item-label">Homepage copy</span>
          </div>
          <div className="lp-app-sidebar-item">
            <div className="lp-app-sidebar-dot" />
            <span className="lp-app-sidebar-item-label">Market report</span>
          </div>
        </div>

        {/* Main area */}
        <div className="lp-app-main">
          <div className="lp-app-topbar">
            <span className="lp-app-topbar-title">Maple Properties — Homepage</span>
            <span className="lp-app-topbar-badge">AI Active</span>
          </div>
          <div className="lp-app-messages">
            <div className="lp-app-msg lp-app-msg--user">
              <div className="lp-app-msg-bubble">
                Update the homepage hero with luxury spring listings and a stronger CTA
              </div>
            </div>
            <div className="lp-app-msg lp-app-msg--ai">
              <div className="lp-app-msg-avatar" style={{ background: '#d97706', borderRadius: '50%' }} />
              <div>
                <div className="lp-app-msg-bubble">
                  <div className="lp-app-msg-label">Claude</div>
                  Drafting hero update with spring messaging and elevated CTA copy. Staged for approval below.
                </div>
                <div className="lp-app-action-card">
                  <span className="lp-app-action-card-icon">⚡</span>
                  WordPress · update_page · "Homepage Hero" · awaiting approval
                </div>
              </div>
            </div>
          </div>
          <div className="lp-app-input-bar">
            <div className="lp-app-input-mock">
              <span className="lp-app-input-text">Ask the team anything…</span>
              <div className="lp-app-input-send">↑</div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating mobile card */}
      <div className="lp-mockup-mobile">
        <div className="lp-mockup-mobile-notch">
          <div className="lp-mockup-mobile-notch-pill" />
        </div>
        <div className="lp-mockup-mobile-body">
          <div className="lp-mockup-mobile-stat">
            <div className="lp-mockup-mobile-stat-label">Tasks Today</div>
            <div className="lp-mockup-mobile-stat-value">12</div>
          </div>
          <div className="lp-mockup-mobile-stat">
            <div className="lp-mockup-mobile-stat-label">Live Pages</div>
            <div className="lp-mockup-mobile-stat-value lp-mockup-mobile-stat-value--green">34</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Suite icons (inline SVG) ───────────────────────────────────────────────────
const IcoBuilding = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="2" width="16" height="20" rx="1"/>
    <path d="M9 22V12h6v10"/>
    <line x1="9"  y1="6"  x2="9.01"  y2="6"/>
    <line x1="15" y1="6"  x2="15.01" y2="6"/>
    <line x1="9"  y1="10" x2="9.01"  y2="10"/>
    <line x1="15" y1="10" x2="15.01" y2="10"/>
  </svg>
);
const IcoCart = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
  </svg>
);
const IcoActivity = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </svg>
);
const IcoUtensils = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/>
    <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/>
  </svg>
);
const IcoMic = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
  </svg>
);

// ── Suite data for landing page ────────────────────────────────────────────────
const LANDING_SUITES = [
  {
    icon:    <IcoBuilding />,
    name:    'Real Estate Suite',
    desc:    'Sites, listings, valuations, and client tools — built for agents and brokers.',
    status:  'available',
    color:   '#3b82f6',
    colorBg: 'rgba(59,130,246,0.1)',
  },
  {
    icon:    <IcoCart />,
    name:    'E-Commerce Suite',
    desc:    'Product pages, promotions, and customer workflows for online stores.',
    status:  'coming-soon',
    color:   '#a855f7',
    colorBg: 'rgba(168,85,247,0.1)',
  },
  {
    icon:    <IcoActivity />,
    name:    'Fitness & Wellness Suite',
    desc:    'Scheduling, member communication, and coaching program management.',
    status:  'coming-soon',
    color:   '#22c55e',
    colorBg: 'rgba(34,197,94,0.1)',
  },
  {
    icon:    <IcoUtensils />,
    name:    'Restaurant Suite',
    desc:    'Menus, reservations, promotions, and front-of-house communications.',
    status:  'coming-soon',
    color:   '#f97316',
    colorBg: 'rgba(249,115,22,0.1)',
  },
  {
    icon:    <IcoMic />,
    name:    'Creator Suite',
    desc:    'Audience growth, content pipelines, and monetization workflows.',
    status:  'coming-soon',
    color:   '#14b8a6',
    colorBg: 'rgba(20,184,166,0.1)',
  },
];

// ── RE spotlight feature items ─────────────────────────────────────────────────
const RE_FEATURES = [
  {
    icon: '🏡',
    title: 'Property Website Management',
    desc: 'AI writes, updates, and publishes your listings and pages. Every change is staged for your approval before anything goes live.',
  },
  {
    icon: '📊',
    title: 'Valuation & Comps Engine',
    desc: 'Comps analysis, pricing recommendations, and market reports generated on demand — ready for your review and client delivery.',
  },
  {
    icon: '✉️',
    title: 'Client Communications',
    desc: 'Automated follow-ups, listing updates, and drip content drafted by AI and sent only after you approve them.',
  },
  {
    icon: '🔒',
    title: 'Approval-Gated Publishing',
    desc: 'Nothing touches your website or CRM without your explicit sign-off. Every action is logged with timestamp and context.',
  },
];


// ── LandingPage ────────────────────────────────────────────────────────────────
export default function LandingPage({ onAuthSuccess, initialAuthTab, reMode }) {
  const [authTab, setAuthTab] = useState(reMode ? (initialAuthTab || 'login') : null);

  function openAuth(tab) { setAuthTab(tab); }
  function closeAuth()   { setAuthTab(null); }

  function handleAuthSuccess(user) {
    closeAuth();
    onAuthSuccess(user);
  }

  React.useEffect(() => {
    if (initialAuthTab) setAuthTab(initialAuthTab);
    else if (reMode) setAuthTab('login');
  }, [initialAuthTab, reMode]);

  // ── RE standalone entry screen ─────────────────────────────────────────────
  if (reMode) {
    return (
      <div className="re-entry-root">
        <div className="re-entry-card">
          <div className="re-entry-brand">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            <span className="re-entry-brand-name">Real Estate Suite</span>
          </div>
          <h1 className="re-entry-headline">Manage your properties and clients</h1>
          <p className="re-entry-sub">
            Property workspaces, document management, e-signature workflows,
            and AI-powered valuations — built for real estate agents.
          </p>
          <div className="re-entry-actions">
            <button className="re-btn-primary" style={{ flex: 1 }} onClick={() => openAuth('login')}>
              Sign In
            </button>
            <button className="re-btn-ghost" style={{ flex: 1 }} onClick={() => openAuth('signup')}>
              Create Account
            </button>
          </div>
          <div className="re-entry-platform-link">
            <a href="/" onClick={e => { e.preventDefault(); localStorage.removeItem('re_mode'); window.location.reload(); }}>
              Access the full 3AImigos platform →
            </a>
          </div>
        </div>
        {authTab && (
          <AuthModal
            initialTab={authTab}
            onSuccess={handleAuthSuccess}
            onClose={closeAuth}
          />
        )}
      </div>
    );
  }

  function scrollTo(id) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <div className="lp-root">

      {/* ── Header ──────────────────────────────────────────────────────────── */}
      <header className="lp-header">
        <div className="lp-header-inner">
          <a className="lp-logo" href="#top" onClick={e => e.preventDefault()}>
            <img src="/logo.svg" alt="3AImigos" className="lp-logo-img" />
            <span className="lp-logo-wordmark">3<em>AI</em>migos</span>
          </a>

          <nav className="lp-nav" aria-label="Main navigation">
            <a className="lp-nav-link" href="#features" onClick={e => { e.preventDefault(); scrollTo('features'); }}>How It Works</a>
            <a className="lp-nav-link" href="#suites"   onClick={e => { e.preventDefault(); scrollTo('suites'); }}>Suites</a>
            <a className="lp-nav-link" href="#re-suite" onClick={e => { e.preventDefault(); scrollTo('re-suite'); }}>Real Estate</a>
            <button className="lp-nav-link lp-nav-login" onClick={() => openAuth('login')}>Login</button>
            <div className="lp-nav-sep" aria-hidden="true" />
            <button className="lp-nav-cta" onClick={() => openAuth('signup')}>Free Trial</button>
          </nav>
        </div>
      </header>

      {/* ── Hero ────────────────────────────────────────────────────────────── */}
      <section className="lp-hero" id="top">
        <div className="lp-hero-inner">

          {/* Left: copy + CTAs */}
          <div className="lp-hero-left">
            <div className="lp-hero-eyebrow">
              <div className="lp-hero-eyebrow-dot" />
              AI Business Platform
            </div>

            <h1 className="lp-hero-headline">
              One Platform.{' '}
              <span className="lp-hero-headline-accent">Every Industry.</span>{' '}
              Powered by AI.
            </h1>

            <p className="lp-hero-sub">
              3AImigos gives your team an AI co-pilot and an industry-specific
              suite designed around how your business actually runs — not a generic
              chatbot you have to bend to your workflow.
            </p>

            <div className="lp-hero-actions">
              <button className="lp-btn-primary" onClick={() => openAuth('signup')}>
                Start Free Trial
              </button>
              <button className="lp-btn-secondary" onClick={() => scrollTo('suites')}>
                See the Suites ↓
              </button>
            </div>

            <div className="lp-hero-trust">
              <span>Free to start</span>
              <span className="lp-hero-trust-dot" />
              <span>No credit card</span>
              <span className="lp-hero-trust-dot" />
              <span>Real Estate Suite live now</span>
            </div>
          </div>

          {/* Right: mockup */}
          <div className="lp-hero-right">
            <DashboardMockup />
          </div>

        </div>
      </section>

      {/* ── How It Works ────────────────────────────────────────────────────── */}
      <section className="lp-features" id="features">
        <div className="lp-section-inner">
          <p className="lp-section-label">How It Works</p>
          <h2 className="lp-section-heading">A platform that works the way you do</h2>
          <p className="lp-section-sub">
            AI that proposes, humans that decide. 3AImigos orchestrates multiple AI
            models around your industry's real workflows — and nothing executes
            without your approval.
          </p>

          <div className="lp-feature-grid">
            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-feature-icon--blue">🤖</div>
              <h3 className="lp-feature-title">Multi-Model AI Orchestration</h3>
              <p className="lp-feature-desc">
                Claude, ChatGPT, and Gemini work together in structured workflows —
                each model doing what it does best, coordinated by the platform so
                you get better output than any single model alone.
              </p>
              <ul className="lp-feature-bullets">
                <li>Parallel analysis and drafting</li>
                <li>Approval-gated task execution</li>
                <li>WordPress content publishing</li>
                <li>Automated research and outlines</li>
              </ul>
            </div>

            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-feature-icon--purple">🧩</div>
              <h3 className="lp-feature-title">Industry Suites</h3>
              <p className="lp-feature-desc">
                Each suite brings specialized tools, AI workflows, and memory
                designed for a specific industry — so you're not configuring a
                blank canvas, you're using something built for your work.
              </p>
              <ul className="lp-feature-bullets">
                <li>Industry-specific AI prompts</li>
                <li>Tailored task and approval flows</li>
                <li>Suite-scoped memory and context</li>
                <li>New suites added as the platform grows</li>
              </ul>
            </div>

            <div className="lp-feature-card">
              <div className="lp-feature-icon lp-feature-icon--green">👥</div>
              <h3 className="lp-feature-title">Team &amp; Permissions</h3>
              <p className="lp-feature-desc">
                Role-based access keeps admins in control while giving agents and
                writers the right level of access — no more over-sharing or
                manual permissioning.
              </p>
              <ul className="lp-feature-bullets">
                <li>Admin and standard roles</li>
                <li>Account lifecycle management</li>
                <li>Full audit log of all actions</li>
                <li>Secure session-based auth</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── Suites ──────────────────────────────────────────────────────────── */}
      <section className="lp-suites" id="suites">
        <div className="lp-section-inner">
          <p className="lp-section-label">The Suite Model</p>
          <h2 className="lp-section-heading">Built for your industry, not every industry</h2>
          <p className="lp-section-sub">
            Each suite is a focused tool shaped around one type of business.
            Start with what you need now. Add more as you grow.
          </p>

          <div className="lp-suites-grid">
            {LANDING_SUITES.map(suite => (
              <div
                key={suite.name}
                className={`lp-suite-card${suite.status === 'available' ? ' lp-suite-card--active' : ' lp-suite-card--soon'}`}
              >
                <div className="lp-suite-card-icon" style={{ color: suite.color, background: suite.colorBg }}>
                  {suite.icon}
                </div>
                <div className="lp-suite-card-body">
                  <div className="lp-suite-card-name">{suite.name}</div>
                  <div className="lp-suite-card-desc">{suite.desc}</div>
                </div>
                <div className="lp-suite-card-footer">
                  {suite.status === 'available' ? (
                    <span className="lp-suite-badge lp-suite-badge--live">Available Now</span>
                  ) : (
                    <span className="lp-suite-badge lp-suite-badge--soon">Coming Soon</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Real Estate Spotlight ───────────────────────────────────────────── */}
      <section className="lp-re-spotlight" id="re-suite">
        <div className="lp-section-inner">
          <p className="lp-section-label" style={{ color: '#f59e0b' }}>Now Available</p>
          <h2 className="lp-section-heading">Start with the Real Estate Suite</h2>
          <p className="lp-section-sub">
            The first live suite — designed from the ground up for real estate teams
            who need to publish faster, stay consistent, and keep full control.
          </p>

          <div className="lp-re-grid">
            {RE_FEATURES.map(f => (
              <div key={f.title} className="lp-re-card">
                <div className="lp-re-card-icon">{f.icon}</div>
                <div>
                  <div className="lp-re-card-title">{f.title}</div>
                  <p className="lp-re-card-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="lp-re-cta">
            <button className="lp-btn-primary" onClick={() => openAuth('signup')}>
              Get Started with Real Estate →
            </button>
          </div>
        </div>
      </section>

      {/* ── Trust ───────────────────────────────────────────────────────────── */}
      <section className="lp-trust" id="about">
        <div className="lp-trust-grid">
          <div className="lp-trust-copy">
            <p className="lp-trust-label">Built for Real-World Operations</p>
            <h2 className="lp-trust-heading">
              Reliable. Controlled. Built for how real teams actually work.
            </h2>
            <p className="lp-trust-body">
              Every AI action in 3AImigos flows through a human approval gate before
              anything touches your website, CRM, or data. The platform was designed
              around real business workflows — not the other way around.
            </p>
            <div className="lp-trust-stats">
              <div className="lp-trust-stat">
                <div className="lp-trust-stat-value">3<span>×</span></div>
                <div className="lp-trust-stat-label">AI models working in parallel</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-stat-value">100<span>%</span></div>
                <div className="lp-trust-stat-label">Actions require your approval</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-stat-value">0</div>
                <div className="lp-trust-stat-label">Changes made without your review</div>
              </div>
              <div className="lp-trust-stat">
                <div className="lp-trust-stat-value">∞</div>
                <div className="lp-trust-stat-label">Audit log history retained</div>
              </div>
            </div>
          </div>

          <div className="lp-trust-pillars">
            <div className="lp-trust-pillar">
              <span className="lp-trust-pillar-icon">🔒</span>
              <div>
                <div className="lp-trust-pillar-title">Approval-Gated by Design</div>
                <p className="lp-trust-pillar-text">
                  No AI action executes automatically. Every proposal enters a review
                  queue — you approve, reject, or modify before anything runs.
                </p>
              </div>
            </div>
            <div className="lp-trust-pillar">
              <span className="lp-trust-pillar-icon">📋</span>
              <div>
                <div className="lp-trust-pillar-title">Full Audit Trail</div>
                <p className="lp-trust-pillar-text">
                  Every login, approval, content change, and system event is logged
                  with timestamp, user, and context — so nothing is ever a mystery.
                </p>
              </div>
            </div>
            <div className="lp-trust-pillar">
              <span className="lp-trust-pillar-icon">⚡</span>
              <div>
                <div className="lp-trust-pillar-title">Real-Time Collaboration</div>
                <p className="lp-trust-pillar-text">
                  Your team sees the same AI conversations, proposals, and task state
                  in real time — no duplicate work, no version confusion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Final CTA ───────────────────────────────────────────────────────── */}
      <section className="lp-cta">
        <p className="lp-section-label">Get Started Today</p>
        <h2 className="lp-cta-heading">
          Your industry suite is ready. Your AI team is waiting.
        </h2>
        <p className="lp-cta-sub">
          Start with the Real Estate Suite — or get access to the full platform
          and build your stack as your business grows.
        </p>
        <div className="lp-cta-actions">
          <button className="lp-btn-primary" onClick={() => openAuth('signup')}>
            Create Free Account →
          </button>
          <button className="lp-btn-secondary" onClick={() => openAuth('login')}>
            Sign In to Existing Account
          </button>
        </div>
        <p className="lp-cta-note">
          <span>Free to start · No credit card · Cancel any time</span>
        </p>
      </section>

      {/* ── Footer ──────────────────────────────────────────────────────────── */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-copy">
            © {new Date().getFullYear()} 3AImigos. All rights reserved.
          </div>
          <div className="lp-footer-links">
            <button className="lp-footer-link" onClick={() => openAuth('login')}>Log In</button>
            <button className="lp-footer-link" onClick={() => openAuth('signup')}>Sign Up</button>
            <button className="lp-footer-link" onClick={() => scrollTo('suites')}>Suites</button>
            <button className="lp-footer-link" onClick={() => scrollTo('re-suite')}>Real Estate</button>
            <a className="lp-footer-link" href="/privacy">Privacy</a>
            <a className="lp-footer-link" href="/terms">Terms</a>
          </div>
        </div>
      </footer>

      {/* ── Auth Modal ──────────────────────────────────────────────────────── */}
      {authTab && (
        <AuthModal
          initialTab={authTab}
          onSuccess={handleAuthSuccess}
          onClose={closeAuth}
        />
      )}
    </div>
  );
}
